import {Injectable} from '@angular/core';
import {CurrentUser, Tokens} from '../models/user';
import { Http, Headers, Response} from '@angular/http';
import {Constants} from './constants-service';

@Injectable()
export class TokensService {

  constructor(private http: Http, private url: Constants) { }

  getToken(): Tokens {
    const currentUser: CurrentUser = JSON.parse(sessionStorage.getItem('currentTokens'));
    const token = currentUser.tokens;
    return token;
  }

  tokenRefresh() {
    const url = '//' + this.url.BASE_URL + ':' + this.url.PORT +  '/api/refresh';

    const headers: Headers = new Headers(
      {'Authorization': 'Bearer ' + this.getToken().refresh,
        'Content-Type': 'application/x-www-form-urlencoded'});

    return this.http.get(url, {headers: headers})
      .map((response: CustomTokenResponse) => {
        const curUsr: CurrentUser = JSON.parse(response._body);
        sessionStorage.setItem('currentTokens', JSON.stringify({tokens: curUsr.tokens}));
      });
  }

}

export class CustomTokenResponse implements Response {
  constructor(
    public type: any,
    public url: any,
    public ok: any,
    public status: any,
    public statusText: any,
    public bytesLoaded: any,
    public totalBytes: any,
    public headers: any,
    public json: any,
    public text: any,
    public arrayBuffer: any,
    public blob: any,
    public _body?: any,
  ) {}
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/services/tokens.service.ts